import { Component, OnInit } from '@angular/core';
import { AppInfoService } from 'core/app-info/app-info.service';
import { Router } from '@angular/router';
import countryMappings from './country-mappings';

@Component({
  selector: 'app-country-select',
  templateUrl: './country-select.component.html',
  styleUrls: ['./country-select.component.scss'],
  standalone: false
})
export class CountrySelectComponent implements OnInit {
  countryList = this.appInfoService.userData.countryCodes || [];
  countryInfo = countryMappings;

  constructor(
    private appInfoService: AppInfoService,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  onCountrySelect(country: string) {
    this.appInfoService.selectCountry(country)
      .subscribe(() => {
        this.appInfoService.countrySelected$.next(undefined);
        if (this.appInfoService.isNSLocaleSelected()) {
          this.router.navigate(['/quotes']);
        } else {
          this.router.navigate(['/accounts']);
        }
      });
  }
}
